export const categories = ['목', '화', '토', '금', '수'];

export const fiveElementColors = {
  목: 'rgba(var(--v-theme-fiveColor03), 1)',
  화: 'rgba(var(--v-theme-fiveColor01), 1)',
  토: 'rgba(var(--v-theme-fiveColor05), 1)',
  금: 'rgba(var(--v-theme-fiveColor04), 1)',
  수: 'rgba(var(--v-theme-fiveColor02), 1)',
};

export const chartColors = ['transparent', '#F47A49'];
